import { Component } from "@angular/core";
import { Error401Component } from "../../components/error-401/error-401";
import { FullScreenLoaderComponent } from "../../components/full-screen-loader/full-screen-loader";
import { AuthFormComponent } from "../../components/auth/auth-form/auth-form";
import { MatCard, MatCardModule } from "@angular/material/card";
import { NgClass, NgIf, NgOptimizedImage } from "@angular/common";
import { ConfigProvider } from "../../../config-provider.service";
import { TranslateService } from "@ngx-translate/core";
import { MatIcon, MatIconModule } from "@angular/material/icon";


@Component({
  selector: 'eula-terms-page',
  providers: [],
  styleUrls: ['./eula-terms.scss'],
  standalone: true,
  imports: [
    Error401Component,
    FullScreenLoaderComponent,
    AuthFormComponent,
    MatCardModule,
    NgIf,
    NgOptimizedImage,
    NgClass,
    MatIconModule
  ],
  templateUrl: './eula-terms.html'
})
export class EulaTermsPageComponent {

  public image = '';

  public isEulaEnOpened = false;
  public isEulaFrOpened = true;
  public isEulaItOpened = false;

  public eulaTitleEn = 'End User License Agreement';
  public eulaTitleFr = 'Contrat de Licence Utilisateur Final';
  public eulaTitleIt = 'Contratto di Licenza per l\'Utente Finale';

  constructor (
    public conf: ConfigProvider,
  ) {
    this.image = conf.assetsUrl + 'img/app-logo_color.png';
  }

  public onTitleClicked(lang: 'EN' | 'FR' |  'IT') {
    switch (lang) {
      case 'EN':
        this.isEulaEnOpened = !this.isEulaEnOpened;
        break;
      case 'FR':
        this.isEulaFrOpened = !this.isEulaFrOpened;
        break;
      case 'IT':
        this.isEulaItOpened = !this.isEulaItOpened;
        break;
    }
  }

}
